
import React, { useState, useEffect } from "react";
import { Box, Radio, RadioGroup, FormControlLabel, Typography } from "@mui/material";
import { FaStarOfLife } from "react-icons/fa6";

const CustomRadioButton = ({ label, name, value, onChange, options = [] ,important}) => {

    const [status, setStatus] = useState(value || options[0]?.value || "");

    useEffect(() => {
        setStatus(value);
    }, [value]);

    const handleChange = (event) => {
        const newValue = event.target.value;
        setStatus(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <div>
            {/* <label
                style={{
                    fontSize: "16px",
                    display: "block",
                }}
            >

            </label> */}
            <Typography variant="subtitle1" sx={{ color: "gray" }}>
                {/* I want the service provided at? */}
                {label}
                {important && (
                    <FaStarOfLife style={{ color: '#F53E5C', fontSize: "8px", marginLeft: "3px" }} />
                )}
            </Typography>
            <Box>
                <RadioGroup name={name} value={status} onChange={handleChange} row>
                    {options.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            value={option.value}
                            name={name}
                            control={
                                <Radio
                                    sx={{
                                        color: "var(--main-color)",
                                        fontSize: "16px",
                                        "&.Mui-checked": { color: "var(--main-color)" },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '20px', // 👈 Adjust this to make the circle smaller
                                        },
                                    }}
                                />
                            }
                            label={option.label}
                        />
                    ))}
                </RadioGroup>
            </Box>
        </div>
    );
}

export default CustomRadioButton;
